import { ReactElement } from "react";
import { IIndicator, IIndicatorData } from "../../../../types";
import { CircularProgress, Typography } from "@mui/material";
import { getPalette } from "../../../../configuration/configuration";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import RemoveIcon from "@mui/icons-material/Remove";
import { useFetch } from "../../../../system/useFetch";

interface IProps {
  dataContext: IIndicator;
}

const Consolidate = ({ dataContext }: IProps): ReactElement => {
  const { data } = useFetch<IIndicatorData>({ module: "system", query: "getIndicatorDataContext",  payload: { nodeID: dataContext.nodeID, nodeType: dataContext.nodeType, nodeIndicatorID: dataContext.nodeIndicatorID } });

  if (!data) {
    return (
      <div className="border-bottom p-1 mb-1 display-flex-row justify-content-center">
        <CircularProgress className=""/>
      </div>
    );
  }

  return (
    <div className="border-bottom p-1 mb-1" >
      <div>
        <Typography variant="h6" >{data.title}</Typography>
        { data && data.properties.map((item, index) => {

          let background = getPalette().statusColor.gray.background;
          if (item.isOk !== null) {
            background = item.isOk ? getPalette().statusColor.good.background : getPalette().statusColor.error.background;
          }

          const value = parseFloat(item.value);

          return(
            <div key={`ind-${dataContext.nodeIndicatorID}-prop-${index}`} className="display-flex-row align-items-center">
              {item.color && <div className="mr-1" style={{ background: item.color, borderRadius: 10, width: 10, height: 10 }}/>}
              <strong className="flex-grow-1" >{item.name}</strong>
              <strong >
                {value.toLocaleString(undefined, { minimumFractionDigits: 1 })}
                {item.unit && <sub className="ml-1" style={{ fontSize: "0.7em" }}>{`[${item.unit}]`}</sub>}
              </strong>
              {item.direction &&
                <div className="display-flex-row flex-grow-0 ml-1 justify-content-center align-items-center">
                  { item.direction === "UP" && <ArrowUpwardIcon style={{ color: "whitesmoke", background, verticalAlign: "center" }} fontSize="small"/> }
                  { item.direction === "DOWN" && <ArrowDownwardIcon style={{ color: "whitesmoke", background, verticalAlign: "center" }} fontSize="small"/> }
                  { item.direction === "UNDEFINED" && <RemoveIcon style={{ color: "whitesmoke", background, verticalAlign: "center" }} fontSize="small"/> }
                </div>
              }
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Consolidate;
